module.exports = __webpack_public_path__ + "static/media/cup.0062e9a1.svg";